import React from 'react';

export function SkillCategory({
  title,
  icon,
  items,
  isOpen,
  onToggle,
  defaultColor,
}) {
  return (
    <>
      <button
        type="button"
        onClick={onToggle}
        className="mb-2.5 flex w-full cursor-pointer items-center rounded-lg border border-[#00f3ff]/[0.18] bg-[#142542]/[0.62] px-4 py-2 text-left transition-all duration-200 hover:border-[#00f3ff]/40 hover:bg-[#00f3ff]/[0.08]"
      >
        <span className="flex min-w-[56px] shrink-0 items-center">{icon}</span>
        <div className="my-1 min-w-0 flex-1 text-base leading-normal text-[#e8effd]">
          {title}
        </div>
        {isOpen ? (
          <svg
            className="h-6 w-6 shrink-0 fill-current text-[#e8effd]"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
          </svg>
        ) : (
          <svg
            className="h-6 w-6 shrink-0 fill-current text-[#e8effd]"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
          </svg>
        )}
      </button>
      {isOpen && (
        <div className="flex flex-wrap pb-8 pl-2 sm:pl-16">
          {items.map((e) => {
            const itemColor = e.color || defaultColor;
            return (
              <span
                key={e.name}
                className="mr-2 mt-3 inline-flex h-8 items-center justify-center rounded-full border border-white/30 px-3 font-mono text-[0.8125rem] font-bold text-[#e8effd] transition-all duration-200 hover:-translate-y-px hover:bg-[#00f3ff]/[0.08] hover:shadow-[0_0_10px_rgba(0,243,255,0.25)]"
                style={
                  itemColor
                    ? { color: itemColor, borderColor: itemColor }
                    : undefined
                }
              >
                {e.name}
              </span>
            );
          })}
        </div>
      )}
    </>
  );
}
